export class YouTube {
    static init(): void {
        this.loadYouTubeAPI();
    }

    private static loadYouTubeAPI(): void {
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScript = document.getElementsByTagName('script')[0]!;
        firstScript.parentNode!.insertBefore(tag, firstScript);

        (window as any).onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady;
    }

    private static onYouTubeIframeAPIReady(): void {
        const playerDivs = document.querySelectorAll('.youtube-player')

        playerDivs.forEach((element, index) => {
            const videoId = element.getAttribute('data-video-id');
            if (!videoId) {
                console.warn(`No video ID found for YouTube player.`);
                return; 
            }

            const playerId = `youtube-player-${index}`
            element.id = playerId;

            let players: YT.Player[] = [];

            players.push(new YT.Player(playerId, {
                height: '360',
                width: '640',
                videoId: videoId,
                playerVars: {
                    playsinline: 0,
                    controls: 1,
                    enablejsapi: 1,
                    autoplay: 0
                }
            }));
        });
    }
}